import React from "react";
import "./styles.css";

const Footer = () => {
   const year = new Date().getFullYear();   // current year
   return (
      <>
         <footer>
            <a
               target="_blank"
               href="https://www.linkedin.com/in/amresh1kumar/"
               rel="noopener noreferrer"
            >
               LinkedIn
            </a>
            <a
               target="_blank"
               href="https://x.com/amresh1kumar"
               rel="noopener noreferrer"
            >
               X
            </a>
            <a
               target="_blank"
               href="https://github.com/amresh1kumar"
               rel="noopener noreferrer"
            >
               Github
            </a>
            <div>
               <p className="copyright">Copyright © {year}</p>
            </div>
         </footer>
      </>
   );
};

export default Footer;
